import React, { useEffect, useMemo, useState } from 'react'
import { Box, Button, CircularProgress, DialogTitle, Grid, Modal, Typography, useMediaQuery } from '@mui/material'
import Dialog from '@mui/material/Dialog'
import { Elements } from '@stripe/react-stripe-js'
import { StripeElementsOptions, loadStripe } from '@stripe/stripe-js'
import axios from 'axios'
import format from 'date-fns/format'
import { useNavigate, useParams } from 'react-router-dom'
import { AppConstants } from 'AppConstants/AppConstants'
import Footer from 'components/Footer'
import Header from 'components/Header'
import HorizontalCalendar from 'components/shared/HorizontalCalendar'
import { useAppDispatch, useAppSelector } from 'redux/store'
import { CheckoutForm } from './CheckoutForm'
import styles from './Payment.module.scss'

const PaymentReferral = () => {
  const navigate = useNavigate()
  const { id } = useParams()
  const [disableBackButton, setDisableBackButton] = useState(false)
  const selectedPlanInfo = useAppSelector((state) => state.referralPersist.paymentPlanReferral)
  const purchasedPlan = useAppSelector((state) => state.referralPersist.purchasedPlanReferral)

  //cardPayment
  const STRIPE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLISH_KEY || ''
  const stripePromise = loadStripe(STRIPE_PUBLIC_KEY)

  const options: StripeElementsOptions = {
    clientSecret: purchasedPlan?.clientSecret,
    appearance: {
      // theme: 'night',
      variables: {
        colorPrimary: 'var(--color-primary)',
        colorBackground: 'var(--color-background)',
        colorText: 'var(--color-text-primary)',
        borderRadius: '8px',
      },
    },
  }

  async function getProfile() {
    try {
      const response: any = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/auth/me`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('userToken')}`,
          'x-platform-id': process.env.REACT_APP_PLATFORM_ID || '',
        },
      })
      // if (response?.data?.data?.screeningStatus === '') {
      //   navigate('/welcome')
      // }
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    getProfile()
  }, [])

  return (
    <div>
      <div className={styles.paymentContainer}>
        <Header
          headerText="Add Payment Details"
          showBackButton={true}
          onBack={() => {
            disableBackButton ? undefined : navigate(`/referral/${id}/confirm-visit`)
          }}
        ></Header>
        <Elements stripe={stripePromise} options={options}>
          <div className={styles.paymentContainerDetails}>
            <CheckoutForm
              clientSecret={purchasedPlan?.clientSecret}
              planId={purchasedPlan?.paymentId}
              purchaseAmount={selectedPlanInfo ? selectedPlanInfo[0]?.amount / 100 : 60}
              disableBackButton={() => {
                setDisableBackButton(true)
              }}
              enableBackButton={() => {
                setDisableBackButton(false)
              }}
            ></CheckoutForm>
          </div>
        </Elements>
      </div>
    </div>
  )
}

export default PaymentReferral
